/**
 * selects deviceId
 */

export const deviceIdSelector = ({ persistedData: { settings } }) =>
  settings.deviceId;
